import { InternalNote } from "@beneficiary/domain/models/internal-notes/internal-note.model";

export class CreateInternalNote {
    constructor(
        public note: InternalNote["note"],
        public beneficiary: InternalNote["beneficiary"],
    ) {}
}
